<div class="flex-center py-6">
  <div class="narrow-card-container">
    <div class="card">
      <div class="card-body p-4 p-sm-5">
        <div class="row flex-between-center mb-2">
          <div class="col-auto">
            <h5>{{ "general.forgottenPassword" | translate }}</h5>
          </div>
        </div>
        @if (invalidLink) {
        <div class="notification my-2">
          <span class="icon bi-info-circle me-2"></span>
          <span class="text my-a">{{
            "forgottenPasswordChange.invalidLink" | translate
          }}</span>
        </div>
        <div class="mb-3">
          <button
            class="btn btn-primary d-block w-100 mt-3"
            type="button"
            (click)="cancel()"
          >
            {{ "general.continue" | translate }}
          </button>
        </div>
        } @else {
        @if (accountHint) {
        <div class="mb-2 text-600">{{ accountHint }}</div>
        }
        <div class="notification my-2">
          <span class="icon bi-info-circle me-2"></span>
          <span class="text my-a">{{
            "forgottenPasswordChange.newPasswordInfoText" | translate
          }}</span>
        </div>
        <form [formGroup]="form" (ngSubmit)="onSubmit()">
          <div class="mb-3">
            <app-validated-input
              label="general.password"
              inputFormControlName="newPassword"
              [inputFormControl]="$any(form.controls['newPassword'])"
              type="password"
              [validationTrainslations]="{
                required: 'login.passwordIsRequired',
                minlength: 'forgottenPasswordChange.passwordMinLength'
              }"
            />
          </div>
          <div class="mb-3">
            <app-validated-input
              label="forgottenPasswordChange.passwordAgain"
              inputFormControlName="confirmPassword"
              [inputFormControl]="$any(form.controls['confirmPassword'])"
              type="password"
              [validationTrainslations]="{
                required: 'login.passwordIsRequired',
                mismatch: 'forgottenPasswordChange.passwordMismatch'
              }"
            />
          </div>
          @if (errorMessage) {
          <div class="text-danger small mb-2">{{ errorMessage }}</div>
          }
          <div class="mb-3">
            <button
              class="btn btn-primary d-block w-100 mt-3"
              type="submit"
              [disabled]="loading"
            >
              {{ "general.continue" | translate }}
            </button>
          </div>
          <div class="mb-3">
            <button
              class="btn btn-falcon d-block w-100 mt-3"
              type="button"
              (click)="cancel()"
            >
              {{ "general.cancel" | translate }}
            </button>
          </div>
        </form>
        }
      </div>
    </div>
  </div>
</div>
